export default __webpack_public_path__ + "images/Z2.bee356c.png";